







































import Vue from 'vue'

export default Vue.extend({
  name: 'HomepageNews',
  mounted() {
    this.$api('/news').then(
      (response) => (this.items = response.data['hydra:member'])
    )
  },
  data: () => ({
    items: [],
  }),
})
